export const CAJA_VARIANTS = {
  JSE: 'default_jse',
  JSE_SG: 'jse_sg',
  DEFAULT: 'default_V2'
} as const;

export type CajaVariant = (typeof CAJA_VARIANTS)[keyof typeof CAJA_VARIANTS];
